<app-header 
  (filterChange)="onCategoryFilterChange($event)"
  (brandFilterChange)="onBrandFilterChange($event)"
  (openFilterChange)="onOpenFilterChange($event)"
  (searchFilterChange)="onSearchFilterChange($event)"
  >
</app-header>

<section class="category-section">
  <div class="row-container">
    <div class="row">
      <div class="col-25 mr-10 shop-by-category">
        
        <mat-tab-group class="outline-tab red-tab" mat-stretch-tabs animationDuration="0ms" mat-align-tabs="start">
          <mat-tab>
            <ng-template mat-tab-label>
           
             Category List
            </ng-template>
            <!-- <h1 class="heading-2">Shop By Category</h1> -->
            <ng-container *ngIf="categoryList && categoryList.length > 0">
              <ul class="category-list scrollbar-1">
                <li
                  *ngFor="let category of categoryList | filter: searchInput,let i=index"
                  [class.active]="category.categoryCode === selectedCategory"
                  (click)="sidebarSelectedCategory(category)"
                >
                  <img [src]="getCategoryImage(category)" alt="" />
                  {{ category.categoryName }}
                </li>
              </ul>
            </ng-container>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
         
              Brand List
            </ng-template>
            <ul class="category-list brand-list" >
              <li *ngFor="let brandData of brandList; let i=index" >
                <img src="{{imgPrefix}}{{brandData?.brandImages?.logo?.links?.logo}}" alt="" onerror="this.src='../../../assets/img/NoImg.png'"/>
                <span (click)="navigateToBrandPage(brandData?.idBrand, brandData?.brandName)">{{ brandData?.brandName}} </span>
              </li>
            </ul>
          </mat-tab>
        
       
        </mat-tab-group>
        


     

      </div>
      <div class="col-75 category-view" *ngIf="selectedCategoryResponse">
        <h2 class="heading-3">{{ selectedCategoryResponse?.defaultChildCategoryDetails?.categoryName }}</h2>
        <div class="product-category" *ngFor="let category of selectedcategoryList">
          <label class="line-after"><span>{{ category.categoryName }}</span></label>
          <ng-container *ngIf="category?.childCategories">
            <ul *ngIf="category.childCategories">
              <li *ngFor="let subCategory of category.childCategories">
                <div class="product-card" (click)="oncontentSearchFilterChange(subCategory)">
                  <img style="cursor:pointer;" [src]="getContentImage(subCategory)" alt="">
                  {{ subCategory.categoryName }}
                </div>
              </li>
            </ul>
          </ng-container>
          <ng-container *ngIf="category?.childCategories==null">
            <ul> 
            <li>
            <div class="product-card" (click)="oncontentSearchFilterChange(category)">
              <img style="cursor:pointer;" [src]="getContentImage(category)" alt="">
              <!-- {{ category.categoryName }} -->
            </div>
          </li>
          </ul>
          </ng-container>
        </div>
      </div>
      
      
    </div>
  </div>
</section>
